export class LoginResponse {
  constructor(public readonly isSuccess: boolean, public readonly message?: string) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/login/login-response.ts